<template>
  <div class="page-container expense-table-page">
    <portal to="page-name">Gerenciamento de tabelas</portal>
    <div class="loading loading-lg mt-2" v-if="loading" />
    <div class="card card-page" v-else>
      <div class="card-header">
        <div class="card-title">Gerenciamento de tabelas</div>
        <div class="text-dark-gray mt-1">Configure preços, regras e outros</div>
      </div>
      <div class="card-body">
        <st-tabs ref="expense-table-tabs">
          <st-tab id="tab-data" name="Dados principais">
            <div class="columns">
              <div class="column col-6 col-md-12 col-sm-12 form-group"
                   :class="{'has-error': $v.form.name.$error}">
                <label class="form-label">Nome da tabela</label>
                <input type="text"
                       class="form-input"
                       v-model="form.name"
                       @blur="$v.form.name.$touch()"
                       placeholder="Nome da tabela de valores"
                >
              </div>
              <div class="column col-2 col-md-4 col-sm-12 form-group"
                   :class="{'has-error': $v.form.startDate.$error}">
                <label class="form-label">Vigência início</label>
                <div class="input-group">
                  <dx-input-date
                    id="appointment-patient-birth-date"
                    class="form-input text-center"
                    v-model="form.startDate"
                    @blur="$v.form.startDate.$touch()"
                  />
                </div>
              </div>
              <div class="column col-2 col-md-4 col-sm-12 form-group"
                   :class="{'has-error': $v.form.endDate.$error}">
                <label class="form-label">Vigência término</label>
                <dx-input-date
                  id="end-date"
                  class="form-input text-center"
                  v-model="form.endDate"
                  @blur="$v.form.endDate.$touch()"
                />
              </div>
              <div class="column col-2 col-md-4 col-sm-12 form-group"
                   :class="{'has-error': $v.form.type.$error}">
                <label class="form-label">Tipo</label>
                <select class="form-select"
                        v-model="form.type"
                        @blur="$v.form.type.$touch()"
                >
                  <option v-for="(text, value) in tableTypes"
                          :value="value"
                          :key="value"
                  >{{ text }}
                  </option>
                </select>
              </div>
              <div class="column form-group" v-if="isCbhpm"
                   :class="{'has-error': $v.form.cbhpm.editionCode.$error}">
                <label class="form-label">Edição</label>
                <select class="form-select"
                        v-model="form.cbhpm.editionCode"
                        @blur="$v.form.cbhpm.editionCode.$touch()">
                  <option value="">[Selecione]</option>
                  <option v-for="(text, value) in cbhpmEditions"
                          :value="value" :key="value">{{ text }}</option>
                </select>
              </div>
              <div class="column col-3 col-md-12 col-sm-12 form-group" v-if="isCbhpm"
                   :class="{'has-error': $v.form.cbhpm.calculationCode.$error}">
                <label class="form-label">Tabela de cálculo</label>
                <select class="form-select"
                        v-model="form.cbhpm.calculationCode"
                        @blur="$v.form.cbhpm.calculationCode.$touch()"
                        @change="setCbhpmValues">
                  <option value="">[Selecione]</option>
                  <option v-for="(item, i) in cbhpmItems"
                          :value="item.code" :key="i">{{ item.name }}</option>
                </select>
              </div>
              <div class="column col-2 col-md-4 col-sm-12 form-group" v-if="isCbhpm"
                   :class="{'has-error': $v.form.cbhpm.operationalCost.$error}">
                <label class="form-label">Custo Operacional</label>
                <dx-input-number class="form-input"
                                 v-model="form.cbhpm.operationalCost"
                                 @blur="$v.form.cbhpm.operationalCost.$touch()"
                                 :precision="4"
                />
              </div>
              <div class="column col-2 col-md-4 col-sm-12 form-group" v-if="isCbhpm">
                <label class="form-label">Valor m² do Filme</label>
                <dx-input-number class="form-input"
                                 v-model="form.cbhpm.film"
                                 :precision="4"
                />
              </div>
              <div class="column form-group" v-if="isCbhpm">
                <label class="form-label">Coeficiente Porte</label>
                <div class="input-group">
                  <select class="form-select"
                          v-model="form.cbhpm.factor"
                          style="max-width: 80px">
                    <option value="+">Acrés.</option>
                    <option value="-">Decrés.</option>
                  </select>
                  <dx-input-number class="form-input"
                                   v-model="form.cbhpm.coefficient"
                                   :precision="4"
                  />
                  <button class="btn btn-icon btn-action btn-warning input-group-btn"
                          @click="setCbhpmValues">
                    <fa-icon :icon="['fal', 'sync']" />
                  </button>
                </div>
              </div>
            </div>

            <div class="accordion" v-if="isCbhpm && form.cbhpm.postageItems.length > 0">
              <input type="checkbox"
                     id="accordion-postage"
                     name="accordion-checkbox" hidden>
              <label class="accordion-header"
                     for="accordion-postage">
                <i class="icon icon-arrow-right mr-1" />
                Portes
              </label>
              <div class="accordion-body">
                <div class="accordion-detail">
                  <div class="postage-items">
                    <h6>Portes</h6>
                    <div class="columns">
                      <div class="column col-4 col-md-4 col-sm-12">
                        <div v-for="(item, i) in form.cbhpm.postageItems.slice(0, 14)" :key="i">
                          <div class="input-group">
                            <span class="input-group-addon">{{ item.postage }}</span>
                            <dx-input-number
                              class="form-input"
                              :class="{'is-error': $v.form.cbhpm.postageItems
                              .$each[i].value.$error}"
                              @blur="$v.form.cbhpm.postageItems.$each[i].value.$touch()"
                              v-model="item.value"
                              :precision="2"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="column col-4 col-md-4 col-sm-12">
                        <div v-for="(item, i) in form.cbhpm.postageItems.slice(14, 28)" :key="i">
                          <div class="input-group">
                            <span class="input-group-addon">{{ item.postage }}</span>
                            <dx-input-number
                              class="form-input"
                              :class="{'is-error': $v.form.cbhpm.postageItems
                              .$each[i + 14].value.$error}"
                              @blur="$v.form.cbhpm.postageItems.$each[i + 14].value.$touch()"
                              v-model="item.value"
                              :precision="2"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="column col-4 col-md-4 col-sm-12">
                        <div v-for="(item, i) in form.cbhpm.postageItems.slice(28, 42)" :key="i">
                          <div class="input-group">
                            <span class="input-group-addon">{{ item.postage }}</span>
                            <dx-input-number
                              class="form-input"
                              :class="{'is-error': $v.form.cbhpm.postageItems
                              .$each[i + 28].value.$error}"
                              @blur="$v.form.cbhpm.postageItems.$each[i + 28].value.$touch()"
                              v-model="item.value"
                              :precision="2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="stenci-group" v-if="isBrasindice || isSimpro">
              <div class="text-bold text-info mb-2">
                A atualização automática de preços via
                {{ isBrasindice ? 'Brasíndice' : 'Simpro' }}
                está em desenvolvimento.
              </div>
              <div>
                Você pode adicionar os produtos e realizar a precificação manual
                até a liberação do recurso.
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">Observações</label>
              <textarea class="form-input" rows="2"
                        v-model="form.notes"></textarea>
            </div>
          </st-tab>
          <st-tab id="tab-expenses" name="Despesas">
            <div class="empty mt-2" v-if="form.expenses.length === 0">
              <div class="empty-icon">
                <fa-icon :icon="['fal', 'info-circle']" size="3x"/>
              </div>
              <p class="empty-title h5">Despesas</p>
              <p class="empty-subtitle">Nenhuma despesa cadastrada.
                Clique no botão abaixo para cadastrar.
              </p>
              <div class="action">
                <button class="btn btn-primary btn-icon btn-icon-left"
                        @click="findExpenseModalShow = true">
                  <fa-icon :icon="['fal', 'plus']"/>Adicionar despesas
                </button>
              </div>
            </div>
            <template v-else>
              <div class="stenci-group">
                <div class="columns">
                  <div class="column col-4 col-md-6 col-md-12 form-group">
                    <label class="form-label">Filtrar tipo</label>
                    <select class="form-select" v-model="filter.type">
                      <option value="">Todos</option>
                      <option v-for="(text, value) in expenseTypes"
                              :value="value" :key="value">{{ text }}</option>
                    </select>
                  </div>
                  <div class="column form-group">
                    <label class="form-label">Pesquisar</label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-input"
                        v-model="filter.search"
                        placeholder="Pesquisar por nome da despesa">
                      <button class="btn btn-neutral btn-action input-group-btn btn-icon"
                              tabindex="-1">
                        <fa-icon :icon="['fal', 'search']" />
                      </button>
                    </div>
                  </div>
                  <div class="column col-auto mb-2" style="align-self: flex-end">
                    <button class="btn btn-secondary btn-icon btn-icon-left"
                            @click="findExpenseModalShow = true">
                      <fa-icon :icon="['fal', 'plus']"/>Adicionar despesas
                    </button>
                  </div>
                </div>
              </div>
              <div class="empty mt-2" v-if="filteredExpenses.length === 0">
                <div class="empty-icon">
                  <fa-icon :icon="['fal', 'info-circle']" size="2x"/>
                </div>
                <p class="empty-title h5">Despesas</p>
                <p class="empty-subtitle">Nenhuma despesa encontrada com este filtro</p>
              </div>
              <table class="table table-hover" v-else>
                <thead>
                <tr>
                  <th class="hide-md hide-sm" style="width: 40px">#</th>
                  <th class="hide-md hide-sm" style="width: 120px">Código</th>
                  <th>Descrição</th>
                  <th class="hide-md hide-sm" style="width: 80px">Tabela</th>
                  <th class="text-right" style="width: 120px">Valor plano</th>
                  <th class="text-right" style="width: 120px">Valor paciente</th>
                  <th class="text-right" style="width: 140px">Valor repasse</th>
                  <th style="width: 40px" />
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in filteredExpenses" :key="i">
                  <td class="text-center hide-md hide-sm">{{ i + 1 }}</td>
                  <td class="text-center hide-md hide-sm"
                      :class="{'has-error': $v.form.expenses
                      .$each[getExpenseIndex(item)].code.$error}">
                    <input
                      type="text"
                      class="form-input input-sm"
                      v-model="item.code"
                      @blur="$v.form.expenses.$each[getExpenseIndex(item)].code.$touch()"
                      v-mask="'00.00.00.00.00'"
                      placeholder="00.00.00.00"
                    >
                  </td>
                  <td>
                    <span class="hover-link" @click="openUpdateExpenseModal(item)">
                       {{ item.expense.name }}
                    </span>
                    <span class="text-warning tooltip"
                          data-tooltip="Existem exceções para esta despesa"
                          v-if="item.professionals.length > 0">
                      <fa-icon :icon="['fal', 'info-circle']" />
                    </span>
                  </td>
                  <td class="hide-md hide-sm"
                      :class="{'has-error': $v.form.expenses.$each[getExpenseIndex(item)]
                      .tableCode.$error}">
                    <select
                      class="form-select select-sm"
                      v-model="item.tableCode"
                      @blur="$v.form.expenses.$each[i].tableCode.$touch()">
                      <option value="">[Selecione]</option>
                      <option
                        v-for="(text, value) in expenseTables"
                        :value="value"
                        :key="value"
                      >{{ value }}
                      </option>
                    </select>
                  </td>
                  <td class="text-right"
                      :class="{'has-error': $v.form.expenses.$each[getExpenseIndex(item)]
                      .definition.$error}">
                    <dx-input-number
                      class="form-input input-sm"
                      v-model="item.definition.insuranceValue"
                      @blur="$v.form.expenses.$each[getExpenseIndex(item)].definition.$touch()"
                      :disabled="item.definition.feeValue > 0
                      || item.definition.operationalCostValue > 0
                      || item.definition.filmValue > 0"
                      :precision="2"
                    />
                  </td>
                  <td class="text-right"
                      :class="{'has-error': $v.form.expenses.$each[getExpenseIndex(item)]
                      .definition.$error}">
                    <dx-input-number
                      class="form-input input-sm"
                      v-model="item.definition.particularValue"
                      @blur="$v.form.expenses.$each[getExpenseIndex(item)].definition.$touch()"
                      :precision="2"
                    />
                  </td>
                  <td class="text-right">
                    <div class="input-group">
                      <dx-input-number
                        class="form-input input-sm"
                        v-model="item.definition.transferValue"
                        :precision="2" maxlength="7"
                      />
                      <select
                        class="form-select select-sm"
                        v-model="item.definition.transferType"
                        style="max-width: 2.5rem; background-color: #f8f9fa">
                        <option value="percent">%</option>
                        <option value="value">R$</option>
                      </select>
                    </div>
                  </td>
                  <td>
                    <button
                      class="btn btn-sm btn-action btn-icon btn-error"
                      @click="removeExpense(item.expense.id)">
                      <fa-icon :icon="['fal', 'times']" />
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <div class="action-group">
                <div class="columns">
                  <div class="column col-12 form-group tooltip" v-if="!isNew"
                       data-tooltip="Atualizar planos de saúde e movimentações">
                    <button class="btn btn-secondary btn-icon btn-icon-left btn-block"
                            :class="{loading: savingExpenseInsurances}"
                            :disabled="savingExpenseInsurances"
                            @click="updateExpenseInsurances">
                      <fa-icon :icon="['fal', 'list']" />Atualizar planos e contas
                    </button>
                  </div>
                  <div class="column col-12 form-group tooltip"
                       data-tooltip="Atualizar regras e valores da tabela">
                    <button class="btn btn-warning btn-icon btn-icon-left btn-block"
                            @click="openBulkUpdateModal">
                      <fa-icon :icon="['fal', 'layer-group']" />Atualização em massa
                    </button>
                  </div>
                  <div class="column col-12 form-group tooltip" v-if="!isNew"
                       data-tooltip="Atualizar valores da tabela via CBHPM">
                    <button class="btn btn-gray btn-icon btn-icon-left btn-block"
                            v-if="isCbhpm && hasCbhpmValues"
                            @click="openCbhpmModal">
                      <fa-icon :icon="['fal', 'sync']" />Atualizar despesas via CBHPM
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </st-tab>
        </st-tabs>
      </div>
      <div class="card-footer">
        <button class="btn btn-primary btn-icon btn-icon-left mr-1"
                :class="{loading: saving}"
                :disabled="saving"
                @click="save">
          <fa-icon :icon="['fal', 'save']" />Salvar
        </button>
        <button class="btn" @click="$router.back()">
          Voltar
        </button>
      </div>
    </div>

    <find-expense-modal
      v-if="findExpenseModalShow"
      @selected="findExpenseModalSelected"
      @close="findExpenseModalShow = false"
    />

    <bulk-update-modal
      v-if="bulkUpdateModalShow"
      :filtered-ids="filteredExpenses.map(({ expense }) => expense.id)"
      :expenses="form.expenses"
      @close="bulkUpdateModalShow = false"
    />

    <update-expense-modal
      v-if="updateExpenseModal.show"
      :data="updateExpenseModal.data"
      @save="saveUpdateExpense"
      @close="updateExpenseModal.show = false"
    />

    <update-by-cbhpm-modal
      v-if="updateByCbhpmModalShow"
      :cbhpm="form.cbhpm"
      :items="form.expenses"
      @save="saveCbhpm"
      @close="updateByCbhpmModalShow = false"
    />
  </div>
</template>

<script>
import { required } from 'vuelidate/src/validators';
import { minLength, minValue } from 'vuelidate/lib/validators';
import { cbhpmEditions } from 'src/data/cbhpm-editions';
import { tables as expenseTables } from 'src/data/expense-tables';
import { types as expenseTypes } from 'src/data/expense-types';
import { types as tableTypes } from 'src/data/table-types';
import moment from 'moment';
import { mergeFrom } from '@/helpers/object';
import { mapActions } from 'vuex';
import fuzzy from 'fuzzy';
import { UPDATE_EXPENSE_TABLE } from '@/data/actions/modules/general';
import formMixin from '../../../mixins/form';
import BulkUpdateModal from './modals/BulkUpdateModal.vue';
import FindExpenseModal from './modals/FindExpenseModal.vue';
import UpdateByCbhpmModal from './modals/UpdateByCbhpmModal.vue';
import UpdateExpenseModal from './modals/UpdateExpenseModal.vue';
import {
  date,
  minDate,
} from '../../../data/validators';

export default {
  mixins: [formMixin],
  components: {
    BulkUpdateModal,
    FindExpenseModal,
    UpdateByCbhpmModal,
    UpdateExpenseModal,
  },
  data() {
    return {
      isNew: false,
      loading: false,
      saving: false,
      savingExpenseInsurances: false,
      cbhpmEditions,
      expenseTables,
      expenseTypes,
      tableTypes,
      professionals: [],
      cbhpmItems: [],
      filter: {
        type: '',
        search: '',
      },
      findExpenseModalShow: false,
      bulkUpdateModalShow: false,
      updateExpenseModal: {
        show: false,
        data: null,
      },
      updateByCbhpmModalShow: false,
      form: this.blankForm(),
    };
  },
  validations() {
    const oneGreaterThanZero = (definition) => {
      if (!definition) return false;
      return definition.insuranceValue > 0 || definition.particularValue > 0;
    };

    const rules = {
      form: {
        name: { required },
        type: { required },
        startDate: { required, date },
        endDate: { required, date },
        cbhpm: {
          calculationCode: {},
          editionCode: {},
          operationalCost: {},
          postageItems: {},
        },
        expenses: {
          $each: {
            code: { required, minLength: minLength(11) },
            tableCode: { required },
            definition: {
              oneGreaterThanZero,
            },
          },
        },
      },
    };

    if (this.form.startDate) {
      rules.form.endDate = { required, date, minDate: minDate(this.form.startDate) };
    }

    if (this.isCbhpm) {
      rules.form.cbhpm.calculationCode = { required };
      rules.form.cbhpm.editionCode = { required };
      rules.form.cbhpm.operationalCost = { required };
      rules.form.cbhpm.postageItems = {
        $each: {
          value: { required, minValue: minValue(0.0001) },
        },
      };
    }

    return rules;
  },
  async mounted() {
    this.isNew = /create$/.test(this.$route.path);
    this.init();
  },
  computed: {
    isCbhpm() {
      return this.form.type === 'cbhpm';
    },
    hasCbhpmValues() {
      return this.isCbhpm && this.form.cbhpm.editionCode && this.form.cbhpm.calculationCode;
    },
    isBrasindice() {
      return this.form.type === 'brasindice';
    },
    isSimpro() {
      return this.form.type === 'simpro';
    },
    filteredExpenses() {
      let { expenses } = this.form;

      if (this.filter.type) {
        expenses = expenses.filter(item => item.expense.type === this.filter.type);
      }

      const search = this.filter.search.trim();

      if (search) {
        const results = fuzzy.filter(search, expenses, {
          extract: (el) => {
            if (el.expense.name) {
              return this.removeAccentuation(el.expense.name);
            }
            return '';
          },
        });
        expenses = results.map(({ original }) => original);
      }

      return expenses;
    },
    canUpdateAccess() {
      return this.$can(UPDATE_EXPENSE_TABLE);
    },
  },
  methods: {
    ...mapActions({
      apiFetchProfessionals: 'apiFetchProfessionals',
    }),
    init() {
      this.loadProfessionals();
      this.loadCbhpmCalculations();

      if (!this.isNew) {
        this.form.id = this.$route.params.id;
        this.load();
      }
    },
    load() {
      this.loading = true;

      return this.$http
        .get(`/expense-tables/${this.form.id}`)
        .then(({ data }) => {
          if (data.type === 'cbhpm') {
            data.cbhpm.editionCode = data.cbhpm.edition.code;
            data.cbhpm.calculationCode = data.cbhpm.calculation.code;
            delete data.cbhpm.edition;
            delete data.cbhpm.calculation;
          }

          this.form = mergeFrom(this.blankForm(), data);
        })
        .catch(() => {
          this.$toast.error('Erro ao carregar tabela de valores!');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadProfessionals() {
      this.apiFetchProfessionals()
        .then((items) => {
          items.forEach((item) => {
            this.expenseConfigModal.professionals.push({
              id: item.id,
              name: item.name,
              council: item.professional.councils[0],
              specialty: item.professional.specialties[0],
            });
            item.professional.specialties.forEach((specialty) => {
              this.professionals.push({
                key: `${item.id}-${specialty.code}`,
                id: item.id,
                name: item.name,
                council: item.professional.councils[0],
                specialty,
              });
            });
          });
        })
        .catch(() => {});
    },
    loadCbhpmCalculations() {
      const params = {
        limit: 0,
      };

      return this.$http.get('/cbhpm-calculations', { params })
        .then(({ data }) => {
          this.cbhpmItems = data.items;
        })
        .catch(() => {});
    },
    findExpenseModalSelected(items) {
      if (!items) {
        return;
      }

      items.forEach((item) => {
        const found = this.form.expenses
          .find(({ expense }) => expense.id === item.id);

        if (!found) {
          const expense = {
            id: item.id,
            type: item.type,
            name: item.name,
            tuss: item?.tuss || null,
            modality: item.modality,
            specialty: item.specialty || null,
            billAs: null,
          };

          this.form.expenses.push(
            mergeFrom(this.blankExpense(), {
              code: expense?.tuss?.code || null,
              tableCode: this.setTableCode(item.type),
              expense,
            }),
          );
        }
      });

      this.findExpenseModalShow = false;
    },
    setTableCode(type) {
      if ([
        'daily',
        'gas',
        'tax',
      ].includes(type)) {
        return '18';
      } if (type === 'material') {
        return '19';
      } if (type === 'medicine') {
        return '20';
      } if ([
        'consultation',
        'evaluation',
        'exam',
        'laboratory',
        'procedure',
        'surgery',
        'physiotherapy',
        'session',
        'service',
      ].includes(type)) {
        return '22';
      } if ([
        'canteen',
        'others',
      ].includes(type)) {
        return '00';
      }
      return '98';
    },
    save() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }

      if (this.form.expenses.length === 0) {
        this.$toast.error('Adicione uma ou mais despesas!');
        return;
      }

      this.saving = true;

      const data = this.clone(this.form);

      if (this.isCbhpm) {
        const calculation = this.cbhpmItems
          .find(({ code }) => code === data.cbhpm.calculationCode);

        data.cbhpm.edition = {
          code: data.cbhpm.editionCode,
          name: this.cbhpmEditions[data.cbhpm.editionCode],
        };

        data.cbhpm.calculation = {
          code: calculation.code,
          name: calculation.name,
        };

        delete data.cbhpm.editionCode;
        delete data.cbhpm.calculationCode;
      }

      data.expenses.forEach((expense) => {
        if (!expense.definition.accreditation.enabled
          || !expense.definition.accreditation?.professional?.id) {
          expense.definition.accreditation.professional = null;
        }
      });

      const request = this.isNew
        ? this.$http.post('/expense-tables', data)
        : this.$http.put(`/expense-tables/${this.form.id}`, data);

      // eslint-disable-next-line consistent-return
      return request
        .then(({ data: result }) => {
          if (this.isNew) {
            this.$router.replace(`/clinical/expense-tables/${result.id}/edit`);
            this.isNew = false;
            this.form.id = result.id;
          }
          this.$toast.show('Registro salvo!');
        })
        .catch(() => {})
        .finally(() => {
          this.saving = false;
        });
    },
    removeExpense(id) {
      const found = this.form.expenses.find(({ expense }) => expense.id === id);
      const i = this.form.expenses.indexOf(found);
      this.form.expenses.splice(i, 1);
    },
    getExpenseIndex(item) {
      const found = this.form.expenses.find(({ expense }) => expense.id === item.expense.id);
      return this.form.expenses.indexOf(found);
    },
    setCbhpmValues() {
      if (!this.form.cbhpm.calculationCode) {
        return;
      }

      this.form.cbhpm.postageItems = [];

      const found = this.cbhpmItems
        .find(({ code }) => code === this.form.cbhpm.calculationCode);

      if (found.operationalCost) {
        this.form.cbhpm.operationalCost = found.operationalCost;
      }

      if (found.film) {
        this.form.cbhpm.film = found.film;
      }

      this.form.cbhpm.postageItems = this.clone(found.postageItems, true);

      if (this.form.cbhpm.coefficient > 0) {
        let percent = this.form.cbhpm.coefficient || 0;

        if (this.form.cbhpm.factor === '-') {
          percent *= -1;
        }

        this.form.cbhpm.postageItems.forEach((item) => {
          item.value += (item.value * (percent / 100));
          return item;
        });
      }
    },
    openBulkUpdateModal() {
      if (!this.canUpdateAccess) {
        return;
      }

      this.bulkUpdateModalShow = true;
    },
    openUpdateExpenseModal(item) {
      if (!this.canUpdateAccess) {
        return;
      }

      const data = this.clone(item);

      if (data.definition?.accreditation?.professional?.id) {
        const { professional } = data.definition.accreditation;
        const { specialty } = data.definition.accreditation.professional;
        data.definition.accreditation.professional.key = `${professional.id}-${specialty.code}`;
      }

      this.updateExpenseModal.data = mergeFrom(this.blankExpense(), data);
      this.updateExpenseModal.show = true;
    },
    saveUpdateExpense(updated) {
      const found = this.form.expenses.find(({ expense }) => expense.id === updated.expense.id);

      const data = this.clone(updated);

      if (!data.definition.accreditation.enabled) {
        data.definition.accreditation.professional = null;
      }

      found.code = data.code;
      found.return = data.return;
      found.tableCode = data.tableCode;
      found.definition = data.definition;
      found.breakInsurance = data.breakInsurance;
      found.requireAuthorization = data.requireAuthorization;
      found.requireClinicalIndication = data.requireClinicalIndication;
      found.requireWayTechnique = data.requireWayTechnique;
      found.professionals = data.professionals;

      this.updateExpenseModal.show = false;
    },
    updateExpenseInsurances() {
      this.$dialog.show('', {
        html:
          '<div class="text-center">'
          + '<h5 class="text-center">Atenção!</h5>'
          + '<div>Deseja realmente atualizar os valores das despesas</div>'
          + '<div>dos planos de saúde vinculados a esta tabela?</div>'
          + '</div>',
        buttons: [
          {
            label: 'Não',
            classes: '',
          }, {
            label: 'Sim',
            classes: 'btn-primary btn-error ml-2',
            click: (close) => {
              this.savingExpenseInsurances = true;
              close();
              return this.$http.put(`/expense-tables/${this.form.id}/update-expense-insurances`)
                .then(() => {
                  this.$toast.show('Valores dos planos atualizados com sucesso!');
                })
                .catch(() => {})
                .finally(() => {
                  this.savingExpenseInsurances = false;
                });
            },
          },
        ],
      });
    },
    openCbhpmModal() {
      if (!this.canUpdateAccess) {
        return;
      }

      this.updateByCbhpmModalShow = true;
    },
    saveCbhpm(expenses) {
      expenses.forEach((item) => {
        const foundExpense = this.form.expenses
          .find(({ expense }) => expense.id === item.id);
        foundExpense.definition.insuranceValue = item.definition.newInsuranceValue;
      });
      this.updateByCbhpmModalShow = false;
    },
    blankForm() {
      return {
        id: '',
        name: '',
        type: 'fixed_table',
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().add(1, 'year').format('YYYY-MM-DD'),
        notes: '',
        cbhpm: {
          editionCode: '',
          calculationCode: '',
          operationalCost: '',
          film: '',
          factor: '+',
          coefficient: '',
          postageItems: [],
        },
        expenses: [],
      };
    },
    blankExpense() {
      return {
        id: '',
        code: '',
        tableCode: '',
        return: null,
        breakInsurance: false,
        expense: {
          id: '',
          type: '',
          name: '',
          modality: '',
          specialty: {
            code: '',
            name: '',
          },
          billAs: null,
        },
        requireAuthorization: false,
        requireClinicalIndication: false,
        requireWayTechnique: false,
        professionals: [],
        definition: this.blankDefinition(),
      };
    },
    blankDefinition() {
      return {
        accreditation: {
          enabled: false,
          professional: {
            key: '',
            id: '',
            name: '',
            council: {
              name: '',
              state: '',
              record: '',
            },
            specialty: {
              code: '',
              name: '',
            },
          },
        },
        accredited: 'pj',
        chValue: '',
        chQuantity: '',
        secondSegment: '',
        operationalCostValue: '',
        filmValue: '',
        filmQuantity: '',
        feeValue: '',
        insuranceValue: 0,
        particularValue: 0,
        taxValue: '',
        taxType: 'pj',
        transferValue: 0,
        transferType: 'value',
        postageCode: '',
        tax: true,
        rate: true,
        discount: true,
        interest: true,
        operationalCost: true,
        film: true,
        insuranceTax: true,
        updateValuesByCbhpm: true,
        priorAuthorization: false,
        reportValue: '',
      };
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';
.expense-table-page {
  .stenci-title {
    margin-top: $layout-spacing-lg;
  }
  .postage-items {
    .input-group {
      margin-bottom: $layout-spacing-sm;
    }
    .input-group-addon {
      color: $gray-color-dark;
      font-weight: bold;
      text-align: center;
      width: 50px;
    }
  }
  .accordion {
    background-color: $gray-color-ultra-light;
    margin: $layout-spacing 0;
    padding: $layout-spacing-sm;
    .accordion-header {
      cursor: pointer;
      font-weight: 500;
    }
    .accordion-body {
      margin: $layout-spacing;
      .accordion-detail {
        border-top: $unit-h solid $border-color;
        padding-top: $layout-spacing;
      }
    }
  }
  .action-group {
    border: $border-width solid $border-color;
    border-radius: $border-radius;
    margin: $layout-spacing-lg 0;
    padding: $layout-spacing-lg;
    .columns {
      margin: 0 auto;
      width: 300px;
      .btn {
        justify-content: left;
        padding: $layout-spacing-lg $layout-spacing;
        svg {
          margin: $layout-spacing-lg $layout-spacing;
        }
      }
    }
  }
  .tab-panel {
    margin-top: $layout-spacing;
  }
}
</style>
